import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const ColorOption = styled.button`
  width: 32px;
  height: 32px;
  margin-right: 8px;
  margin-bottom: 13px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  outline: none;
  box-shadow: ${th('shadows.small')};
  position: relative;
  border: 0px;
  transition: 0.2s;

  :active {
    transform: scale(0.9);
  }

  ::after {
    content: '';
    width: 100%;
    height: 100%;
    border: 3px solid ${th('colors.white')};
    position: absolute;
    top: -3px;
    left: -3px;
    border-radius: 50%;
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    transition: 0.35s;
  }

  @media ${sizes.desktop} {
    margin-bottom: 13px;
    margin-right: 0;
  }
`;

const Option = ({ isActive, item, onClick }) => {
  return <ColorOption isActive={isActive} color={item} onClick={onClick} />;
};

Option.propTypes = {
  isActive: PropTypes.bool,
  item: PropTypes.string,
  onClick: PropTypes.func
};

export default Option;
